import { useCallback } from 'react';
import { useMutation } from 'react-apollo';
import { requestGoogleCalendarDraftTesterOptOut } from '@kiper/account-graphql/google-calendar/mutation';

const useDraftTesterOptOut = () => {
  const [requestMutation] = useMutation(requestGoogleCalendarDraftTesterOptOut);

  const requestOptOut = useCallback(
    ({ email, message }) => requestMutation({ variables: { email, message } }),
    [requestMutation],
  );

  return { requestOptOut };
};

export default useDraftTesterOptOut;
